// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.amn-chart[data-v-65299af0] {\n  margin: 5px;\n}\n.chart-card[data-v-65299af0] {\n  padding: 0;\n  margin: 5px;\n  text-decoration: none;\n}\n", ""]);
// Exports
module.exports = exports;
